<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import {
    resolveGoodsSelectValue,
    collectCreatedGoodsNames,
    applyResolvedGoodsIds,
    findGoodsByTitle,
    filterGoodsOptions,
} from "@/utils/goodsSelect";

/**
 * Starter page component
 */
export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Starter page",
            items: [
                {
                    text: "Utility",
                    href: "/",
                },
                {
                    text: "Starter page",
                    active: true,
                },
            ],

            ismobile: false,
            activeapp: [],
            showmodel: "1",
            userinfo: [],
            safeinfo: [],
            loading: true,
            form: {},
            initializationdata: {},
            activeNames: [],
            showBatchSettingDialog: false,
            batchPrice: 0,
            batchStock: 0,
            batchStockSave: 0,
            showImportDialog: false,
            importFile: null,
            importLoading: false,
             importFormatData: [],
            goodsQuery: "",
        };
    },
    mounted() {
        this.title = this.$t("menuitems.setting.initialization");
        this.items = [
            {
                text: this.$t("menuitems.setting.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.setting.initialization"),
                active: true,
            },
        ];

        this.userinfo = JSON.parse(localStorage.getItem("user"));
        let flag = navigator.userAgent.match(
            /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if (flag) {
            this.ismobile = true;
        }
        this.loading = false
        this.get_initialization()
        
        // 初始化多语言格式数据
        this.importFormatData = [
            { field: 'device_id', description: this.$t('initialization.import.deviceIdDesc'), required: true },
            { field: 'device_name', description: this.$t('initialization.import.deviceNameDesc'), required: false },
            { field: 'goodsname', description: this.$t('initialization.import.goodsNameDesc'), required: false },
            { field: 'price', description: this.$t('initialization.import.priceDesc'), required: false },
            { field: 'sales_volume', description: this.$t('initialization.import.salesVolumeDesc'), required: false },
            { field: 'inventory', description: this.$t('initialization.import.inventoryDesc'), required: false }
        ];
    },
    computed: {
        filteredInitializationGoods() {
            return filterGoodsOptions(
                this.initializationdata && this.initializationdata.goodslist,
                this.goodsQuery
            );
        },
    },
    methods: {
        get_initialization() {
            console.log("get_initialization")
            var that = this
            that.loading = true
            that.$axios
                .post(
                    that.apiuri,
                    {
                        action: "get_initialization",
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.loading = false;
                    that.initializationdata = response.data.data;
                })
                .catch(function (error) {
                    // console.log(error);
                });
        },
        filterInitializationGoods(query) {
            this.goodsQuery = query;
        },
        onGoodsDropdownVisible(visible) {
            if (!visible) this.goodsQuery = "";
        },
        onGoodsSelectChange(row) {
            if (!row) return;
            row.gid = resolveGoodsSelectValue(
                this.initializationdata.goodslist,
                row.gid
            );
        },
        authHeaders() {
            return { headers: { Openid: this.userinfo.openid } };
        },
        refreshGoodsList() {
            var that = this;
            return that.$axios
                .post(that.apiuri, { action: "goodslist" }, that.authHeaders())
                .then(function (response) {
                    if (response.data && response.data.data) {
                        that.$set(
                            that.initializationdata,
                            "goodslist",
                            response.data.data
                        );
                    }
                });
        },
        createGoodsByTitle(title) {
            var that = this;
            var existing = findGoodsByTitle(that.initializationdata.goodslist, title);
            if (existing) {
                return Promise.resolve(existing.id);
            }
            return that.$axios
                .post(
                    that.apiuri,
                    {
                        action: "addgoods",
                        id: 0,
                        title: title,
                        description: "",
                        coverimg: "",
                    },
                    that.authHeaders()
                )
                .then(function (response) {
                    var id = null;
                    if (response.data && response.data.status == 200) {
                        if (response.data.data && response.data.data.id != null) {
                            id = response.data.data.id;
                        } else if (response.data.id != null) {
                            id = response.data.id;
                        }
                    }
                    if (id != null) {
                        var list = that.initializationdata.goodslist || [];
                        if (!findGoodsByTitle(list, title)) {
                            list.push({ id: id, title: title });
                            that.$set(that.initializationdata, "goodslist", list);
                        }
                        return id;
                    }
                    return that.refreshGoodsList().then(function () {
                        var created = findGoodsByTitle(
                            that.initializationdata.goodslist,
                            title
                        );
                        return created ? created.id : title;
                    });
                })
                .catch(function () {
                    return title;
                });
        },
        normalizeCreatedGoods() {
            var that = this;
            var goodsList = that.initializationdata.goodslist || [];
            applyResolvedGoodsIds(that.initializationdata.hdlist, goodsList);
            var names = collectCreatedGoodsNames(
                that.initializationdata.hdlist,
                that.initializationdata.goodslist
            );
            if (!names.length) {
                return Promise.resolve();
            }
            return names
                .reduce(function (promise, name) {
                    return promise.then(function () {
                        return that.createGoodsByTitle(name);
                    });
                }, Promise.resolve())
                .then(function () {
                    applyResolvedGoodsIds(
                        that.initializationdata.hdlist,
                        that.initializationdata.goodslist
                    );
                });
        },
        save_initialization() {
            var that = this;
            that.loading = true;
            that
                .normalizeCreatedGoods()
                .then(function () {
                    return that.$axios.post(
                        that.apiuri,
                        {
                            action: "save_initialization",
                            data: that.initializationdata,
                        },
                        that.authHeaders()
                    );
                })
                .then(function (response) {
                    that.loading = false;
                    that.$message({
                        message: response.data.msg,
                        type: "success",
                    });
                    that.get_initialization();
                })
                .catch(function () {
                    that.loading = false;
                });
        },
        openBatchSettingDialog() {
            this.showBatchSettingDialog = true;
            this.batchPrice = 0;
            this.batchStock = 0;
            this.batchStockSave = 0;
        },
        applyBatchSettings() {
            var that = this;
            if (!that.initializationdata.hdlist || that.initializationdata.hdlist.length === 0) {
                that.$message.error(that.$t('initialization.batch.noData'));
                return;
            }

            // 递归更新所有货道数据
            that.updateHdList(that.initializationdata.hdlist);
            
            that.$message({
                message: that.$t('initialization.batch.success'),
                type: 'success',
            });
            that.showBatchSettingDialog = false;
        },
        updateHdList(hdList) {
            var that = this;
            hdList.forEach(function(item) {
                // 更新价格
                if (that.batchPrice > 0) {
                    item.price = that.batchPrice;
                }
                // 更新销售量
                if (that.batchStock > 0) {
                    item.stock = that.batchStock;
                }
                // 更新库存
                if (that.batchStockSave > 0) {
                    item.stock_save = that.batchStockSave;
                }
                
                // 递归处理子项
                if (item.children && item.children.length > 0) {
                    that.updateHdList(item.children);
                }
            });
        },
        openImportDialog() {
            this.showImportDialog = true;
            this.importFile = null;
        },
        downloadTemplate() {
            // 创建CSV模板内容
            const headers = ['device_id', 'device_name', 'goodsname', 'price', 'sales_volume', 'inventory'];
            const sampleData = [
                ['750005323001', '设备1', '啤酒', '15.50', '500', '2000'],
                ['750005323002', '设备2', '可乐', '8.00', '300', '1500']
            ];
            
            // 构建CSV内容
            let csvContent = headers.join(',') + '\n';
            sampleData.forEach(row => {
                csvContent += row.join(',') + '\n';
            });
            
            // 创建并下载文件
            const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', '设备初始化模板.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        handleFileUpload(file, fileList) {
            this.importFile = file.raw || file;
            return false; // 阻止自动上传
        },
        async importData() {
            var that = this;
            if (!that.importFile) {
                that.$message.error(that.$t('initialization.import.noFile'));
                return;
            }

            that.importLoading = true;
            
            try {
                const data = await that.parseFile(that.importFile);
                const result = that.updateDataFromImport(data);
                
                that.$message({
                    message: that.$t('initialization.import.success', { count: result.updated }),
                    type: 'success',
                });
                
                that.showImportDialog = false;
                that.importFile = null;
            } catch (error) {
                console.error('Import error:', error);
                that.$message.error(that.$t('initialization.import.error'));
            } finally {
                that.importLoading = false;
            }
        },
        parseFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        const content = e.target.result;
                        const lines = content.split('\n');
                        const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
                        
                        const data = [];
                        for (let i = 1; i < lines.length; i++) {
                            if (lines[i].trim()) {
                                const values = lines[i].split(',').map(v => v.trim());
                                const row = {};
                                headers.forEach((header, index) => {
                                    row[header] = values[index] || '';
                                });
                                data.push(row);
                            }
                        }
                        resolve(data);
                    } catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = reject;
                
                if (file.name.toLowerCase().endsWith('.csv')) {
                    reader.readAsText(file, 'UTF-8');
                } else {
                    reject(new Error('Unsupported file format'));
                }
            });
        },
        updateDataFromImport(importData) {
            var that = this;
            let updated = 0;
            
            importData.forEach(importRow => {
                // 处理设备ID，去除可能的单引号前缀
                let deviceId = importRow.device_id;
                if (deviceId) {
                    deviceId = deviceId.toString().replace(/^['']/, '').trim();
                }
                
                if (!deviceId) return;
                
                // 递归查找匹配的设备
                const findAndUpdate = (hdList) => {
                    hdList.forEach(item => {
                        if (item.ED_id === deviceId) {
                            // 更新设备名称
                            if (importRow.device_name) {
                                item.name = importRow.device_name;
                            }
                            // 更新商品名称
                            if (importRow.goodsname) {
                                item.gid = resolveGoodsSelectValue(
                                    that.initializationdata.goodslist,
                                    importRow.goodsname
                                );
                            }
                            // 更新价格
                            if (importRow.price) {
                                item.price = parseFloat(importRow.price) || 0;
                            }
                            // 更新销售量
                            if (importRow.sales_volume) {
                                item.stock = parseInt(importRow.sales_volume) || 0;
                            }
                            // 更新库存
                            if (importRow.inventory) {
                                item.stock_save = parseInt(importRow.inventory) || 0;
                            }
                            updated++;
                        }
                        
                        // 递归处理子项
                        if (item.children && item.children.length > 0) {
                            findAndUpdate(item.children);
                        }
                    });
                };
                
                findAndUpdate(that.initializationdata.hdlist);
            });
            
            return { updated };
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" v-loading="loading">
                        <div style="margin-bottom: 20px;">
                            <el-button type="primary" @click="openBatchSettingDialog">
                                <i class="el-icon-setting"></i>
                                {{ $t('initialization.batch.title') }}
                            </el-button>
                            <el-button type="success" @click="openImportDialog" style="margin-left: 10px;">
                                <i class="el-icon-upload"></i>
                                {{ $t('initialization.import.title') }}
                            </el-button>
                        </div>
                        <el-table :data="initializationdata.hdlist" style="width: 100%;margin-bottom: 20px;" row-key="ED_id"
                            border default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
                            <el-table-column prop="ED_id" :label="$t('initialization.text.ED_id')" sortable width="130">
                            </el-table-column>
                            <el-table-column :label="$t('initialization.text.name')" sortable width="180">
                                <template slot-scope="scope">
                                    <el-input v-if="scope.row.name || scope.row.no==1" v-model="scope.row.name" size="small" style="width: 100%;"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('initialization.text.goodsname')" sortable min-width="240">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.gid" filterable allow-create default-first-option
                                        :placeholder="$t('initialization.text.selectgoods')"
                                        :filter-method="filterInitializationGoods"
                                        @visible-change="onGoodsDropdownVisible"
                                        @change="onGoodsSelectChange(scope.row)">
                                        <el-option value="0" :label="$t('initialization.text.noset')"></el-option>
                                        <el-option v-for="item in filteredInitializationGoods" :key="item.id"
                                            :label="item.title" :value="item.id">
                                            <span>{{ item.title }}</span>
                                            <span class="goods-option-id">ID {{ item.id }}</span>
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('initialization.text.price')" sortable width="120">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.price" :min="0" :max="99999999" :step="0.01"
                                        controls-position="right" size="small" style="width: 100%;"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('initialization.text.values')" sortable width="130">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.stock" :min="0" :max="99999999" :step="1"
                                        controls-position="right" size="small" style="width: 100%;"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('initialization.text.stock')" sortable width="180">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.stock_save" :min="0" :max="99999999" :step="1"
                                        controls-position="right" size="small" style="width: 100%;" placeholder="0"></el-input-number>
                                </template>
                            </el-table-column>
                        </el-table>
                        <p style="text-align: right;">
                            <el-button type="primary" @click="save_initialization">{{ $t('initialization.text.save') }}</el-button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 批量设置对话框 -->
        <el-dialog :title="$t('initialization.batch.title')" :visible.sync="showBatchSettingDialog" width="500px">
            <el-form label-width="120px">
                <el-form-item :label="$t('initialization.batch.price')">
                    <el-input-number 
                        v-model="batchPrice" 
                        :min="0" 
                        :max="99999999" 
                        :step="0.01"
                        controls-position="right" 
                        style="width: 100%;"
                        :placeholder="$t('initialization.batch.pricePlaceholder')">
                    </el-input-number>
                </el-form-item>
                <el-form-item :label="$t('initialization.batch.stock')">
                    <el-input-number 
                        v-model="batchStock" 
                        :min="0" 
                        :max="99999999" 
                        :step="50"
                        controls-position="right" 
                        style="width: 100%;"
                        :placeholder="$t('initialization.batch.stockPlaceholder')">
                    </el-input-number>
                </el-form-item>
                <el-form-item :label="$t('initialization.batch.stockSave')">
                    <el-input-number 
                        v-model="batchStockSave" 
                        :min="0" 
                        :max="99999999" 
                        :step="1000"
                        controls-position="right" 
                        style="width: 100%;"
                        :placeholder="$t('initialization.batch.stockSavePlaceholder')">
                    </el-input-number>
                </el-form-item>
            </el-form>
            <div style="margin-top: 10px; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
                <i class="el-icon-info" style="color: #409eff; margin-right: 5px;"></i>
                <span style="color: #606266; font-size: 12px;">{{ $t('initialization.batch.note') }}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showBatchSettingDialog = false">{{ $t("global.button.cancel") }}</el-button>
                <el-button type="primary" @click="applyBatchSettings()">{{ $t("global.button.ok") }}</el-button>
            </span>
        </el-dialog>
        
        <!-- 导入对话框 -->
        <el-dialog :title="$t('initialization.import.title')" :visible.sync="showImportDialog" width="600px">
            <div style="margin-bottom: 20px;">
                <h4>{{ $t('initialization.import.format') }}</h4>
                <p>{{ $t('initialization.import.formatDesc') }}</p>
                <div style="margin-bottom: 10px;">
                    <el-button type="primary" size="small" @click="downloadTemplate()">
                        <i class="el-icon-download"></i>
                        {{ $t('initialization.import.downloadTemplate') }}
                    </el-button>
                </div>
                <el-table :data="importFormatData" border size="small" style="margin-top: 10px;">
                    <el-table-column prop="field" :label="$t('initialization.import.field')" width="150"></el-table-column>
                    <el-table-column prop="description" :label="$t('initialization.import.description')"></el-table-column>
                     <el-table-column prop="required" :label="$t('initialization.import.required')" width="100">
                         <template slot-scope="scope">
                             <el-tag v-if="scope.row.required" type="danger" size="mini">{{ $t('initialization.import.required') }}</el-tag>
                             <el-tag v-else type="info" size="mini">{{ $t('initialization.import.optional') }}</el-tag>
                         </template>
                     </el-table-column>
                </el-table>
            </div>
            
            <el-upload
                class="upload-demo"
                drag
                action="#"
                :auto-upload="false"
                :on-change="handleFileUpload"
                accept=".csv,.xlsx"
                :show-file-list="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{ $t('initialization.import.uploadText') }}</div>
                <div class="el-upload__tip" slot="tip">{{ $t('initialization.import.uploadTip') }}</div>
            </el-upload>
            
            <div v-if="importFile" style="margin-top: 15px;">
                <el-tag type="success">{{ importFile.name }}</el-tag>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImportDialog = false">{{ $t("global.button.cancel") }}</el-button>
                <el-button type="primary" @click="importData()" :loading="importLoading" :disabled="!importFile">
                    {{ $t("initialization.import.import") }}
                </el-button>
            </span>
        </el-dialog>
    </Layout>
</template>

<style>
.goods-option-id {
    float: right;
    color: #909399;
    font-size: 12px;
    margin-left: 12px;
}
</style>